import React from 'react';
import styled from 'styled-components';
import { Column, LoginButton } from '../../components/styled-components/common';

export const Container = styled.div<{ placeFormOnTop: boolean }>`
  display: flex;
  height: 100vh;
  width: 100vw;
  flex-direction: column;
  align-items: center;
  ${({ placeFormOnTop }) => !placeFormOnTop && `justify-content: center;`}
  // justify-content: center;
  //noinspection CssUnknownTarget
  background-image: url('auth.jpg');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  background-size: 1440px;
  background-color: #f8e5df;
  overflow: scroll;

  @media (max-width: ${({ theme }) => theme.sizes.mobileWidth}) {
    padding-left: 10px;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  padding: 50px 100px;
  border-radius: 8px;
  box-shadow: 0 8px 44px rgba(54, 69, 91, 0.15);
  width: 40em;

  @media (max-width: 1024px) {
    padding: 50px 50px;
  }

  @media (max-width: ${({ theme }) => theme.sizes.mobileWidth}) {
    width: 30em;
    padding: 30px;
    font-size: 12px;
  }
`;

export const SignUpFormContainer = styled(FormContainer)`
  background: none;
  box-shadow: none;
  padding-top: 0;
`;

export const ModalSignupFormContainer = styled.div``;

export const InputHolder = styled(Column)`
  flex: 1;
`;

export const Label = styled.span`
  font-weight: 500;
  font-size: 0.7em;
  margin: 0.5em 0;
  text-align: left;
  color: ${props => props.theme.colors.grey.dark};
  text-transform: uppercase;
`;

export const Input = styled.input`
  box-sizing: border-box;
  width: 100%;
  background: ${props => props.theme.colors.blue.veryLight};
  padding: 0.43em;
  border-radius: 0.2em;
  border: 2px solid ${props => props.theme.colors.blue.veryLight};
  :focus {
    background: white;
    border: 2px solid ${props => props.theme.colors.blue.normal};
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1em;
`;

export const FooterSpan = styled.span`
  margin-top: 1em;
  font-size: 0.9em;

  display: flex;
  align-items: baseline;
  justify-content: center;
`;

export const TCLabel = styled.span`
  font-size: 12px;
  line-height: 14px;
  margin-left: 0.5em;
`;

export const TCLink = styled.a`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.blue.normal};
  cursor: pointer;
`;

export const MainBox = styled('div')<{ img: string }>`
  height: 50vh;
  width: 100%;
  background-color: black;
  display: flex;
  justify-content: center;
  background-image: url(${props => props.img});
  background-size: cover;
  background-position: center;
  align-items: center;
  flex-direction: column;
  gap: 30px;
  font-size: 50px;
  font-weight: 800;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 50vh;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
`;

export const TextBox = styled('div')`
  color: white;
  z-index: 1;
  line-height: 1;

  @media (max-width: ${({ theme }) => theme.sizes.mobileWidth}) {
    font-size: 2rem;
    line-height: 1.1;
  }
`;

export const Content = styled('div')`
  height: 50%;
  width: 30%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 2em;

  'qwerty': {
    background: 'red';
  }
`;

export const SignupButtonContainer = styled.div`
  height: 50%;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 2em;

  'qwerty': {
    background: 'red';
  }
`;

export const SignupComponentContainer = styled.div`
  width: 25%;

  @media (max-width: ${({ theme }) => theme.sizes.mobileWidth}) {
    width: 60%;
  }
`;

export const EmailSignupButton = styled(LoginButton)`
  background-color: #c33c01;
  width: 100%;
  height: 45px;
  justify-content: center;
  border-radius: 10px;
`;

export const SignupSectionContainer = styled.div<{ signUpViaEmail?: boolean }>`
  display: flex;
  align-items: flex-start;
  padding: 0 1em;
  width: 100%;
`;
